import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-responsive"
}




export default /*#__PURE__*/_defineComponent({
  props: {
    borderless: { type: Boolean },
    responsive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  borderless?: boolean;
  responsive?: boolean;
}



return (_ctx: any,_cache: any) => {
  return (__props.responsive)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", {
          class: _normalizeClass(["table", { 'table-borderless': __props.borderless }])
        }, [
          _createElementVNode("thead", null, [
            _renderSlot(_ctx.$slots, "header")
          ]),
          _createElementVNode("tbody", null, [
            _renderSlot(_ctx.$slots, "body")
          ])
        ], 2)
      ]))
    : (_openBlock(), _createElementBlock("table", {
        key: 1,
        class: _normalizeClass(["table", { 'table-borderless': __props.borderless }])
      }, [
        _createElementVNode("thead", null, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _createElementVNode("tbody", null, [
          _renderSlot(_ctx.$slots, "body")
        ])
      ], 2))
}
}

})